import { render, staticRenderFns } from "./SocialAccounts.vue?vue&type=template&id=8c5c6c46&scoped=true"
import script from "./SocialAccounts.vue?vue&type=script&lang=js"
export * from "./SocialAccounts.vue?vue&type=script&lang=js"
import style0 from "./SocialAccounts.vue?vue&type=style&index=0&id=8c5c6c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c6c46",
  null
  
)

export default component.exports